// word-level LCS diff, used to compare variant wordings against the
// canonical text of a node slot without leaving the canvas.

export type DiffToken = { text: string; kind: "same" | "added" | "removed" };

export function wordDiff(a: string, b: string): DiffToken[] {
  const aw = a.split(/\s+/);
  const bw = b.split(/\s+/);
  const m = aw.length;
  const n = bw.length;
  const dp: number[][] = Array.from({ length: m + 1 }, () => new Array(n + 1).fill(0));
  for (let i = m - 1; i >= 0; i -= 1) {
    for (let j = n - 1; j >= 0; j -= 1) {
      dp[i][j] = aw[i] === bw[j] ? dp[i + 1][j + 1] + 1 : Math.max(dp[i + 1][j], dp[i][j + 1]);
    }
  }
  const out: DiffToken[] = [];
  let i = 0;
  let j = 0;
  while (i < m && j < n) {
    if (aw[i] === bw[j]) {
      out.push({ text: aw[i], kind: "same" });
      i += 1;
      j += 1;
    } else if (dp[i + 1][j] >= dp[i][j + 1]) {
      out.push({ text: aw[i], kind: "removed" });
      i += 1;
    } else {
      out.push({ text: bw[j], kind: "added" });
      j += 1;
    }
  }
  while (i < m) { out.push({ text: aw[i], kind: "removed" }); i += 1; }
  while (j < n) { out.push({ text: bw[j], kind: "added" }); j += 1; }
  return out;
}
